import { getThemeBasedOnDomain } from '../lib/helpers';

interface HeaderProps {
  heading: string;
  paragraph?: string;
  hideAuthMode?: boolean;
}

export default function Header(props: HeaderProps) {
  const theme = getThemeBasedOnDomain();

  return (
    <div className="">
      <img
        alt={`${theme.name} Logo`}
        className="h-16 w-16 rounded-md mx-auto"
        src={theme.logo}
      />
      <h1 className="mt-6 text-3xl font-extrabold text-gray-900 mb-3">
        {props.heading}
      </h1>
      <p className="text-zinc-500 mb-3">{props.paragraph}</p>
    </div>
  );
}
